"use strict";

export default function () {
    function updateGridLinesHeight() {
        const gridLines = document.querySelector(".grid-lines");
        if (!gridLines) return;

        const headerHeight = 80;
        const footerHeight = 164;

        // Altura total do documento com scroll incluído
        const documentHeight = document.body.scrollHeight;

        // Altura da grid-lines considerando espaços do header e footer
        const gridHeight = documentHeight - headerHeight - footerHeight;

        // Aplica dinamicamente a altura
        gridLines.style.top = headerHeight + "px";
        gridLines.style.height = gridHeight + "px";
    }

    // Executa ao carregar a página e ao redimensionar
    window.addEventListener("load", updateGridLinesHeight);
    window.addEventListener("resize", updateGridLinesHeight);
    window.addEventListener("scroll", updateGridLinesHeight);
}
